module.exports = __webpack_public_path__ + "static/chameleon-eff-718ce0cc945489bf7b1ed01e70bcfdb7.png";